import CodeScreen from './Code'

export default CodeScreen
